/*jslint eqeq: true, nomen: true, plusplus: true, unparam: true, todo: true, vars: true, browser: true, indent: 3, maxerr: 50 */

/**
 * Manages school pins
 * @param llMap  the liquid layout map instance
 * @param map  the instance of the map the layer exists in
 */
define(['jquery', 'c21/ajax', 'c21/track', 'c21/maps', 'bing', 'c21/maps/PinData', 'c21/Params'], function ($, ajax, track, C21Maps, BingMaps, PinData, Params)  {
   "use strict";

   //C21Maps.SchoolPinLayer = function (llMap, bingMap, schoolTooltipManager) {
   return function (llMap, bingMap, schoolTooltipManager) {
      var self = this,

         // Member variables that need
         // reset when the map is cleared
         m_pinDataById = {},
         m_pinTypeById = {},
         m_shapeById = {},
         m_pinById = {},
         m_pinInViewById = {},
         m_hoverPinId,
         m_clickPinId,
         m_selectedSchoolsById = {},
         m_bModalShowing = false,

         // Enumeration of pin types
         m_pinType = {
            active: 1,
            normal: 2,
            gold: 3
         },

         // School radius in kilometers
         // Default: 1 Mile
         m_iSchoolRadius = 1.609344,

         m_shapeLayer = new BingMaps.Layer(),
         m_smallPinLayer = new BingMaps.Layer(),
         m_largePinLayer = new BingMaps.Layer(),

         m_map = bingMap,
         m_llMap = llMap,

         createPin = function (pinData, loc) {
            var id = pinData.getId(),
               pin = new BingMaps.Pushpin(loc, {
                  zIndex: C21Maps.getZindexFromLoc(
                     loc.latitude,
                     loc.longitude
                  ),
                  icon: '/images/eco/icons/pushpins/pin-gold.png',
                  width: 63,
                  height: 63,
                  anchor: new BingMaps.Point(5, 18)
               });

            C21Maps.onPinHoverIntent(m_map, pin, function () {
               // GA Tracking - hover over school pin on map
               track.doEvent('Schools', 'Mapping Page', 'Hover over a school pushpin');
               schoolTooltipManager.showHoverTooltip(pinData);
               self.setPinHighlighted(id, true);
            }, function () {
               schoolTooltipManager.hideHoverTooltip();
               self.setPinHighlighted(id, false);
            });

            BingMaps.Events.addHandler(pin, 'click', function (e) {
               // GA Tracking - click on school pin on map
               track.doEvent('Schools', 'Mapping Page', 'Click on a school pushpin');
               schoolTooltipManager.showClickTooltip(pinData);
            });

            return pin;
         },

         createShape = function (aBoundary) {
            var aLocation = [];
            $.each(aBoundary, function (i, aLatLon) {
               var iLatitude = aLatLon[0],
                  iLongitude = aLatLon[1],
                  loc = new BingMaps.Location(iLatitude, iLongitude);

               aLocation.push(loc);
            });

            var poly = new BingMaps.Polygon(aLocation, {
               fillColor: new BingMaps.Color(51, 245, 192, 34),
               strokeColor: new BingMaps.Color(100, 50, 50, 50),
               strokeThickness: 3
            });

            return poly;
         },

         /**
          * There is an extreme amount of juggling between layers
          * in schools. Layers will throw errors during the clear()
          * function if we accidentally remove pin that doesn't exist,
          * add a pin that is already in another layer, or some other
          * easy mistake. The following code is a safety net that ensures
          * layer sync issues never occur.
          */

         /** BEGIN SAFETY NET CODE **/
         m_oSchoolInSmallLayer = {},
         m_oSchoolInLargeLayer = {},

         movePinToLargeLayer = function (strSchoolId) {
            var pin = m_pinById[strSchoolId];

            if (m_oSchoolInSmallLayer[strSchoolId]) {
               m_smallPinLayer.remove(pin);
               delete m_oSchoolInSmallLayer[strSchoolId];
            }

            if (!m_oSchoolInLargeLayer[strSchoolId]) {
               m_largePinLayer.add(pin);
               m_oSchoolInLargeLayer[strSchoolId] = true;
            }
         },

         movePinToSmallLayer = function (strSchoolId) {
            var pin = m_pinById[strSchoolId];

            if (m_oSchoolInLargeLayer[strSchoolId]) {
               m_largePinLayer.remove(pin);
               delete m_oSchoolInLargeLayer[strSchoolId];
            }

            if (!m_oSchoolInSmallLayer[strSchoolId]) {
               m_smallPinLayer.add(pin);
               m_oSchoolInSmallLayer[strSchoolId] = true;
            }
         },

         removePin = function (strSchoolId) {
            var pin = m_pinById[strSchoolId];

            if (m_oSchoolInLargeLayer[strSchoolId]) {
               m_largePinLayer.remove(pin);
               delete m_oSchoolInLargeLayer[strSchoolId];
            }

            if (m_oSchoolInSmallLayer[strSchoolId]) {
               m_smallPinLayer.add(pin);
               delete m_oSchoolInSmallLayer[strSchoolId];
            }
         },

         clearPins = function () {
            m_oSchoolInSmallLayer = {};
            m_oSchoolInLargeLayer = {};
            m_smallPinLayer.clear();
            m_largePinLayer.clear();
         },
         /** END SAFETY NET CODE **/

         setPinType = function (id, iType) {
            var iCurrentType = m_pinTypeById[id];
            m_pinTypeById[id] = iType;
            return (iCurrentType === iType);
         },

         setPinActive = function (id, pin) {
            if (setPinType(id, m_pinType.active)) {
               return;
            }

            movePinToLargeLayer(id);

            pin.setOptions({
               icon: '/images/eco/schoolsearch/apple-pin-active.png',
               width: 63,
               height: 63,
               visible: true,
               anchor: new BingMaps.Point(19, 58)
            });
         },

         setPinNormal = function (id, pin) {
            if (setPinType(id, m_pinType.normal)) {
               return;
            }

            movePinToLargeLayer(id);

            pin.setOptions({
               icon: '/images/eco/schoolsearch/apple-pin-normal.png',
               width: 63,
               height: 63,
               visible: true,
               anchor: new BingMaps.Point(19, 58)
            });
         },

         setPinGold = function (id, pin) {
            if (setPinType(id, m_pinType.gold)) {
               return;
            }

            movePinToSmallLayer(id);

            pin.setOptions({
               icon: '/images/eco/icons/pushpins/pin-gold.png',
               width: 0, //19,
               height: 0, //20,
               visible: false,
               anchor: new BingMaps.Point(5, 18)
            });
         },

         setPinActiveVisible = function(id, pin) {
             movePinToLargeLayer(id);
             pin.setOptions({
                icon: '/images/eco/schoolsearch/apple-pin-active.png',
                width: 63,
                height: 63,
                visible: true,
                anchor: new BingMaps.Point(19, 58)
             });
         },
         
         refreshPin = function (id) {
            var pin = m_pinById[id],
               bActive = (id == m_hoverPinId);

            if (!m_bModalShowing && m_selectedSchoolsById[id]) {
               setPinActiveVisible(id, pin);
            } else if (m_selectedSchoolsById[id]) {
               setPinActive(id, pin);
            } else if (m_bModalShowing) {
               if (m_pinInViewById[id]) {
                  if (bActive) {
                     setPinActive(id, pin);
                  } else {
                     setPinNormal(id, pin);
                  }
               } else {
                  setPinGold(id, pin);
               }
            } else {
               removePin(id);
            }
         },

         setShapeVisibility = function (strId, bVisible) {
            var shape = m_shapeById[strId];

            if (!shape) {
               return;
            }

            if (m_selectedSchoolsById[strId]) {
               bVisible = true;
            }

            shape.setOptions({
               visible: bVisible
            });
         },

         addSchool = function (schoolResult) {
            var id = schoolResult.getId();
            if (m_pinById[id]) {
               return;
            }

            // Create the pinData object
            var iLatitude = schoolResult.getLatitude(),
               iLongitude = schoolResult.getLongitude(),
               pinData = new PinData(id, iLatitude, iLongitude),
               loc = pinData.getLocation(),

               // Create the pin
               pin = createPin(pinData, loc);

            m_pinById[id] = pin;
            m_pinDataById[id] = pinData;

            refreshPin(id);
         },

         initialize = function () {
            var pParams = new Params(),
               iRadius = pParams.get("sn");
            if (iRadius) {
               m_iSchoolRadius = (iRadius * 1.609344);
               $("#schoolRadiusSelector").val(iRadius);
            }
            m_selectedSchoolsById = {};
            schoolTooltipManager.setLayer(self);
            m_map.layers.insert(m_shapeLayer);
            m_smallPinLayer.setZIndex(6);
            m_map.layers.insert(m_smallPinLayer);
            m_largePinLayer.setZIndex(7);
            m_map.layers.insert(m_largePinLayer);
            C21Maps.onMapClick(m_map, function (e) {
               schoolTooltipManager.clear();
            });
         };

      initialize();

      self.getSchools = function () {
         return m_pinDataById;
      };

      /**
       * Set the schools currently inside of the view of the user
       * in the modal window
       * 
       * NOTE: Must operate extremely fast, due to
       * being called numerous times as the user scrolls
       */
      self.setSchoolsInView = function (aPinId) {
         var oNewPinsInView = {};
         $.each(aPinId, function (i, iPinId) {
            oNewPinsInView[iPinId] = true;
            if (!m_pinInViewById[iPinId]) {
               m_pinInViewById[iPinId] = true;
               refreshPin(iPinId);
            }
         });

         $.each(m_pinInViewById, function (iPinId, b) {
            if (!oNewPinsInView[iPinId]) {
               if (!m_selectedSchoolsById[iPinId]) {
                  // Since the small pushpins are currently hidden,
                  // it doesn't make any sense to have a tooltip showing
                  // over nothing!
                  var pinData = m_pinDataById[iPinId];
                  schoolTooltipManager.hideTooltipByPinData(pinData);

                  delete m_pinInViewById[iPinId];
                  refreshPin(iPinId);
               }
            }
         });
      };

      /**
       * Set the schools fitting the search criteria
       */
      self.setSchools = function (aSchoolResult) {
         m_bModalShowing = true;
         $.each(m_pinById, function (id, pin) {
            if (!m_selectedSchoolsById[id]) {
               removePin(id);

               var shape = m_shapeById[id];
               if (shape) {
                  shape.setOptions({
                     visible: false
                  });
               }

               delete m_pinById[id];
               delete m_shapeById[id];
               delete m_pinDataById[id];
               delete m_pinInViewById[id];
               delete m_pinTypeById[id];
            }
         });

         $.each(aSchoolResult, function (i, schoolResult) {
            addSchool(schoolResult);
         });
      };

      self.setSchoolRadius = function (iSchoolRadius) {
         m_iSchoolRadius = iSchoolRadius;
      };

      self.setInitialSelectedSchools = function (aSchoolSearchItem) {
         m_selectedSchoolsById = {};
         $.each(aSchoolSearchItem, function (i, schoolResult) {
            var id = schoolResult.getId(),
               aBounds = schoolResult.getBoundary();

            m_selectedSchoolsById[id] = true;
            addSchool(schoolResult);

            self.addShape(id, aBounds);
         });
      };

      self.setSelectedSchools = function (aSelectedSchools) {
         $.each(m_selectedSchoolsById, function (iSchoolId, b) {
            delete m_selectedSchoolsById[iSchoolId];
            refreshPin(iSchoolId);
            setShapeVisibility(iSchoolId, false);
         });

         m_hoverPinId = false;
         $.each(aSelectedSchools, function (i, iSchoolId) {
            //var pinData = m_pinDataById[iSchoolId];
            m_selectedSchoolsById[iSchoolId] = true;
            refreshPin(iSchoolId);
            setShapeVisibility(iSchoolId, true);
         });
      };

      self.hideUnselectedSchools = function () {
         m_bModalShowing = false;
         m_smallPinLayer.setVisible(false);

         $.each(m_pinInViewById, function (id, b) {
            if (!m_selectedSchoolsById[id]) {
               if (m_hoverPinId != id) {
                  var pin = m_pinById[id];
                  pin.setOptions({
                     visible: false
                  });
               }
            }
         });

         // Hide any tooltips that are no longer showing...
         $.each(m_pinDataById, function (id, pinData) {
            if (!m_selectedSchoolsById[id]) {
               schoolTooltipManager.hideTooltipByPinData(pinData);
            }
         });
      };

      self.showUnselectedSchools = function () {
         m_bModalShowing = true;
         m_smallPinLayer.setVisible(true);

         $.each(m_pinInViewById, function (id, b) {
            var pin = m_pinById[id];
            pin.setOptions({
               visible: true
            });
         });
      };

      self.setPinHighlighted = function (id, bActive) {
         if (m_clickPinId) {
            return;
         }
         m_hoverPinId = (bActive) ? id : null;

         if (m_pinById[id]) {
            refreshPin(id);
         }
      };

      self.addShape = function (id, aShapeCoordinates) {
         var shape,
            pinData = m_pinDataById[id],
            loc = pinData.getLocation(),
            oldShape = m_shapeById[id];

         if (oldShape) {
            m_shapeLayer.remove(oldShape);
            delete m_shapeById[id];
         }

         // If the coordinates are not a real shape
         if (aShapeCoordinates.length < 2) {
            shape = m_llMap.getCircle(loc, m_iSchoolRadius, 750, "#323232", 3, 0.4, "#F5C022", 0.2);
         } else {
            shape = createShape(aShapeCoordinates);
         }

         m_shapeLayer.add(shape);
         m_shapeById[id] = shape;
      };

      self.getPinData = function (id) {
         return m_pinDataById[id];
      };

      self.setClickPin = function (pinData, bClickPin) {
         var id = pinData.getId();
         if (bClickPin) {
            m_hoverPinId = id;
            m_clickPinId = id;
            refreshPin(id);
         } else {
            m_hoverPinId = null;
            m_clickPinId = null;
            refreshPin(id);
         }
      };

      self.setShapeVisibility = function (pinData, bVisible) {
         var strId = pinData.getId();
         setShapeVisibility(strId, bVisible);
      };

      self.clearSchools = function () {
         m_pinTypeById = {};
         m_pinDataById = {};
         m_shapeById = {};
         m_pinById = {};
         m_pinInViewById = {};
         m_hoverPinId = false;
         m_clickPinId = false;
         m_selectedSchoolsById = {};
         m_bModalShowing = false;

         m_shapeLayer.clear();

         clearPins();

         schoolTooltipManager.clear();
      };
   };
});
